import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { FormattedMessage } from "react-intl";
import React from "react";
import computeCategoryCellText from "./computeCategoryCellText";
import { injectIntl } from "react-intl";

const CategoryCell = ({
  bankTransactionLines,
  ecritureLines,
  status,
  qualifyPayment,
  intl,
  history
}) => {
  const toolTip = (
    <Tooltip id="tooltip">
      <p>
        <FormattedMessage id="ids_autoQualify_text" />
      </p>
    </Tooltip>
  );

  if (
    bankTransactionLines &&
    bankTransactionLines[0] &&
    bankTransactionLines[0].category &&
    status === "AQUALIFIER"
  ) {
    var forceQualified = true;
  }

  const texts = computeCategoryCellText(bankTransactionLines, ecritureLines, status, intl, history);

  return (
    <div className="payment-category-cell">
      <div className="flex align-items-center">
        <span title={texts.text} className="overflow-ellipsis">
          {texts.divText}
        </span>
        {/* {forceQualified || status === "QUALIFIE_AUTO" ? (
          <OverlayTrigger placement="top" overlay={toolTip}>
            <i className="fa fa-info-circle text-primary" />
          </OverlayTrigger>
        ) : (
          // ) : (
          //   status === "AQUALIFIER" ? (
          //     <OverlayTrigger placement="top" overlay={<p></p>} >
          //       <i className="fa fa-question-circle text-danger" />
          //     </OverlayTrigger>
          <div />
          //)
        )} */}
      </div>
      {forceQualified || status === "QUALIFIE_AUTO" ? (
        <OverlayTrigger placement="top" overlay={toolTip}>
        <i
          onClick={e => {
            e.stopPropagation();
            qualifyPayment();
          }}
          className="fa fa-check-circle text-primary payment-check-icon"
        />
        </OverlayTrigger>
      ) : status === "AQUALIFIER" ? (
        <i className="fa fa-question-circle text-danger payment-check-icon" />
      ) : (
        <div />
      )}
    </div>
  );
};

export default injectIntl(CategoryCell);
